<template>
  <div v-click-outside="hide" class="mr-4 relative" v-if="linkToSSO && appsettings">
    <button
      class="hover:bg-purple-100 inline-block hover:text-purple-500 rounded-full p-1 border border-1 focus:outline-none"
      type="button"
      @click.prevent="toggle"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98z"
        ></path>
      </svg>
    </button>
    <div
      v-show="shouldOpen"
      class="
        origin-top-left
        -ml-6
        transition
        duration-500
        absolute
        left-0
        mt-3
        max-w-md
        w-full
        rounded-lg
        shadow-lg
        py-6
        bg-gray-200
        ring-1 ring-black ring-opacity-5
        focus:outline-none
        apps-container
        px-2
      "
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="user-menu"
    >
      <ul class="list-reset border-b border-gray-300 pb-4 grid grid-cols-2 gap-2">
        <li class="">
          <a
            @click="handleMyAccountClick"
            href="#"
            target="_blank"
            class="flex flex-col items-center justify-start hover:bg-gray-100 py-2 hover:rounded"
          >
            <span class="rounded-full inline-flex items-center justify-center mb-1 w-10 h-10">
              <img :src="assetLink('profile', 'white')" alt="" class="h-10 w-10 rounded-full" />
              <!-- <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 512 512"> -->
              <!-- <image :src="assetLink('profile')" width="20" height="20" /> -->
              <!-- <defs />
                <path
                  fill="#6d7587"
                  d="M256 288.389c-153.837 0-238.56 72.776-238.56 204.925 0 10.321 8.365 18.686 18.686 18.686h439.747c10.321 0 18.686-8.365 18.686-18.686.001-132.142-84.722-204.925-238.559-204.925zM55.492 474.628c7.35-98.806 74.713-148.866 200.508-148.866s193.159 50.06 200.515 148.866H55.492zM256 0c-70.665 0-123.951 54.358-123.951 126.437 0 74.19 55.604 134.54 123.951 134.54s123.951-60.35 123.951-134.534C379.951 54.358 326.665 0 256 0zm0 223.611c-47.743 0-86.579-43.589-86.579-97.168 0-51.611 36.413-89.071 86.579-89.071 49.363 0 86.579 38.288 86.579 89.071 0 53.579-38.836 97.168-86.579 97.168z"
                /> -->
              <!-- </svg> -->
            </span>
            <p class="text-xs text-gray-500 font-semibold font-sans text-center">Account</p>
          </a>
        </li>
        <li v-for="(product, index) in products" :key="index" class="">
          <a :href="product.url" target="_blank" class="flex flex-col items-center justify-start py-2 hover:rounded">
            <span class="rounded-full inline-block mb-1 w-10 h-10">
              <img :src="assetLink(product.slug)" alt="" class="h-10 w-10 rounded-full" />
            </span>
            <p class="text-xs text-gray-500 font-semibold font-sans text-center">
              {{ product.name }}
            </p>
          </a>
        </li>
      </ul>
      <ul class="list-reset pt-4 grid grid-cols-2 gap-2 secondary-apps">
        <li class="">
          <a
            href="https://thesource.social"
            target="_blank"
            class="flex flex-col items-center justify-start py-2 hover:rounded"
          >
            <span class="rounded-full inline-block mb-1 w-10 h-10">
              <img :src="assetLink('the-source', 'white')" alt="" class="h-10 w-10 rounded-full" />
            </span>
            <p class="text-xs text-gray-500 font-semibold font-sans text-center">The Source</p>
          </a>
        </li>
        <li class="">
          <a
            href="https://creativelift.ai"
            target="_blank"
            class="flex flex-col items-center justify-start py-2 hover:rounded"
          >
            <span class="rounded-full inline-block mb-1 w-10 h-10">
              <img :src="assetLink('creative-lift', 'green')" alt="" class="h-10 w-10 rounded-full" />
            </span>
            <p class="text-xs text-gray-500 font-semibold font-sans text-center">CreativeLift</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { appId, appCallbackRoute } from '@/api/workflow';
import projectViewHelpers from '@/mixins/projectViewHelpers';
export default {
  name: 'AppSwitcher',
  mixins: [projectViewHelpers],
  data() {
    return {
      shouldOpen: false,
      settings: null
    };
  },
  async beforeMount() {
    this.settings = window.config();
    if(!window.app()) {
      return;
    }
    this.$store.dispatch('fetchUserProducts');
  },
  computed: {
    ...mapState({
      products: state => state.identity.products
    }),
    linkToSSO() {
      return window.config('auth') != null;
    },
    appsettings() {
      return this.settings;
    }
  },
  methods: {
    assetLink(app, color = 'green') {
      const appSettings = window.config('auth');
      return `${appSettings.assetsUrl}/${app}?color=${color}`;
    },
    handleMyAccountClick() {
      appCallbackRoute(appId())
        .then(route => {
          window.open(this.settings.auth.profileUrl, '_blank').focus();
        })
        .catch(err => {
          this.$router.push({ name: 'my-account' }).catch(() => {});
        });
    },
    async handleLogoutClick() {
      appCallbackRoute(appId())
        .then(route => {
          const redirectTo = `${window.config('auth.logoutUrl')}?continue=${
            window.config('auth.appUrl')
          }`;
          window.location = redirectTo;
        })
        .catch(err => {
          console.error(err);
        });
    },
    toggle() {
      this.shouldOpen = !this.shouldOpen;
    },
    show() {
      this.shouldOpen = true;
    },
    hide() {
      this.shouldOpen = false;
    }
  }
};
</script>

<style scoped>
.secondary-apps {
  border-top: 1px solid rgba(29, 31, 35, 0.1);
}
.bg-white {
  background-color: white;
}
.flex {
  display: flex;
}
.mr-4 {
  margin-right: 1rem;
}
.relative {
  position: relative;
}
.p-1 {
  padding: 0.25rem;
}
.inline-block {
  display: inline-block;
}
.border {
  border-width: 1px;
}
.rounded-full {
  border-radius: 9999px;
}
.hover\:text-purple-500:hover {
  --tw-text-opacity: 1;
  color: rgba(139, 92, 246, var(--tw-text-opacity));
}
.hover\:bg-purple-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(237, 233, 254, var(--tw-bg-opacity));
}
.duration-500 {
  transition-duration: 500ms;
}
.transition {
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter,
    -webkit-backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter,
    backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter,
    backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.origin-top-left {
  transform-origin: top left;
}
.w-full {
  width: 100%;
}
.ring-opacity-5 {
  --tw-ring-opacity: 0.05;
}
.ring-black {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(0, 0, 0, var(--tw-ring-opacity));
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.left-0 {
  left: 0px;
}
.absolute {
  position: absolute;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.max-w-md {
  max-width: 28rem;
}
.-ml-6 {
  margin-left: -1.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}
.apps-container {
  min-width: 170px;
  margin-left: -70px;
  z-index: 999;
}
.apps-container a {
  text-decoration: none;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.gap-2 {
  gap: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.grid {
  display: grid;
}
.border-b {
  border-bottom-width: 1px;
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, var(--tw-border-opacity));
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.justify-start {
  justify-content: flex-start;
}
.items-center {
  align-items: center;
}
.flex-col {
  flex-direction: column;
}
.w-10 {
  width: 2.5rem;
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.h-10 {
  height: 2.5rem;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
.inline-flex {
  display: inline-flex;
}
.border {
  border-width: 1px;
}
.rounded-full {
  border-radius: 9999px;
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, var(--tw-border-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}
.text-center {
  text-align: center;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-semibold {
  font-weight: 600;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
}
ul,
ol {
  list-style: none;
}

.w-10 {
  width: 2.5rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.h-10 {
  height: 2.5rem;
}
.inline-block {
  display: inline-block;
}
.rounded-full {
  border-radius: 9999px;
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgba(75, 85, 99, var(--tw-bg-opacity));
}
img,
video {
  max-width: 100%;
  height: auto;
}
.pt-4 {
  padding-top: 1rem;
}
</style>
